import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_MKB_TEN_TOP,
    GET_MKB_TEN_MID,
    GET_MKB_TEN_BOT
} from "../types";


export const getMKBtenTop = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/voz_diagnoses/top`);
        dispatch({ type: GET_MKB_TEN_TOP, payload: data });
    } catch (error) {
    }
};
  
export const getMKBtenMid = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/voz_diagnoses/mid/${id}`);
        dispatch({ type: GET_MKB_TEN_MID, payload: data });
    } catch (error) {
    }
};
  
export const getMKBtenBot = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/voz_diagnoses/bot/${id}`);
        dispatch({ type: GET_MKB_TEN_BOT, payload: data });
    } catch (error) {
    }
};